<template>
  <q-toolbar
    slot="header"
    color="dark">
    <q-btn
      flat
      @click="toggleLeft">
      <q-icon name="menu" />
    </q-btn>
    <q-toolbar-title>
      SYSTEM
      <div slot="subtitle">ERP</div>
    </q-toolbar-title>
    <message-popover/>
    <task-manager/>
  </q-toolbar>
</template>
<script type="text/javascript">
import { QBtn, QToolbar, QToolbarTitle, QIcon } from 'quasar'
import messagePopover from './MessagePopover.vue'
import taskManager from './TaskManager.vue'
export default {
  components: {
    messagePopover,
    taskManager,
    QBtn,
    QToolbar,
    QToolbarTitle,
    QIcon
  },
  computed: {},
  methods: {
    toggleLeft () {
      this.$parent.toggleLeft()
    }
  }
}
</script>
<style scoped>
.toolbar {
  min-height: 60px;
}

.right-itens a,
.right-itens button {
  margin-right: 10px;
}
</style>
